// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"624":"5b2c03cd","767":"333ca60c"}[chunkId] + ".css";
};